import { ChangeEvent } from "react"
import React from "react"
import styled from "styled-components"
import { SUPPORTED_IMAGE_MIME_TYPE } from "../../../libs/input-image-file"

interface IProps {
  onChange: (ev: ChangeEvent<HTMLInputElement>) => void
  className?: string
}

export class ImageInput extends React.Component<IProps> {
  // 同じファイルを選択した際にonChangeが発火しないのを防ぐため
  private imgKey = 0

  constructor(props: IProps) {
    super(props)
    this.onChange = this.onChange.bind(this)
  }

  public render() {
    return (
      <label className={this.props.className}>
        <File
          type="file"
          accept={SUPPORTED_IMAGE_MIME_TYPE.join(",")}
          onChange={this.onChange}
          key={this.imgKey}
        />
        {this.props.children}
      </label>
    )
  }

  private async onChange(ev: ChangeEvent<HTMLInputElement>) {
    await this.props.onChange(ev)
    this.imgKey++
  }
}

const File = styled.input`
  display: none;
  opacity: 0;
`
